export class ImpersonationStatus {
    impersonating: boolean;
    impersonatedContactId: string;
    impersonatedContactName?: string;
    userFirstName?: string;
    userLastName?: string;
    contactId?: string;
    contactType?: string;
    userEmailAddress?: string;
    membershipLevel: string;
}